import { defineMessages } from 'react-intl'

const scope = `procurify.components.TaxSelectCreate`

export default defineMessages({
  taxSelectAriaLabel: {
    id: `${scope}.taxSelectAriaLabel`,
    defaultMessage: 'Tax select dropdown',
  },
  getTaxesErrorTitle: {
    id: `${scope}.getTaxesErrorTitle`,
    defaultMessage: 'Error',
  },
  getTaxesErrorMessage: {
    id: `${scope}.getTaxesErrorMessage`,
    defaultMessage: 'Failed to get taxes.',
  },
  defaultPlaceholderText: {
    id: `${scope}.defaultPlaceholderText`,
    defaultMessage: 'Select a tax',
  },
  taxCreateErrorTitle: {
    id: `${scope}.taxCreateErrorTitle`,
    defaultMessage: 'Error',
  },
  taxCreateErrorMessage: {
    id: `${scope}.taxCreateErrorMessage`,
    defaultMessage: 'There was an error creating the tax.',
  },
})
